import {ErrorpageState} from '../../interfaces/errorpage-state.interface';
import {createReducer} from '@ngrx/store';


export const initialErrorpageState: ErrorpageState = {};

export const errorpageReducer = createReducer(
  initialErrorpageState,
);
